import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchComponent } from './components/common/search/search.component';
import { MDBBootstrapModule, TableModule } from 'angular-bootstrap-md';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { AnimateOnScrollModule } from 'ng2-animate-on-scroll';
// import { ScrollEventModule } from 'ngx-scroll-event';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ShowAllProfilesComponent } from './components/dashboard/show-all-profiles/show-all-profiles.component';
import { CommonheaderComponent } from './components/dashboard/commonheader/commonheader.component';
import { UpgradeMembershipComponent } from './components/dashboard/upgrade-membership/upgrade-membership.component';
import { ProfileOfTheDayComponent } from './components/dashboard/profile-of-the-day/profile-of-the-day.component';
import { ProfileDashboardSliderComponent } from './components/dashboard/profile-dashboard-slider/profile-dashboard-slider.component';
import { CompleteProfileComponent } from './components/dashboard/complete-profile/complete-profile.component';
import { SearchProfileComponent } from './components/dashboard/search-profile/search-profile.component';
import { ImgPreviewComponent } from './components/dashboard/img-preview/img-preview.component';
import { ProfileImgsliderComponent } from './components/dashboard/profile-imgslider/profile-imgslider.component';
import { DashboardContentLoaderComponent } from './components/common/dashboard-content-loader/dashboard-content-loader.component';
import { ProfilePaginationComponent } from './components/common/profile-pagination/profile-pagination.component';
import { UserDetailsSectionComponent } from './components/dashboard/user-details-section/user-details-section.component';
import { ShowCompleteDetailsOfOtherProfileComponent } from './components/dashboard/show-complete-details-of-other-profile/show-complete-details-of-other-profile.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ModalInfoComponent } from './components/common/modal-info/modal-info.component';
import { ProfileDetailsSectionComponent } from './components/dashboard/profile-details-section/profile-details-section.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { CommonpopupComponent } from './components/common/commonpopup/commonpopup.component';
import { PartnerPreferenceComponent } from './components/common/functional/partner-preference/partner-preference.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { MatSortModule } from '@angular/material/sort';

import { HeaderComponent } from './components/common/header/header.component';
import { AccordionComponent } from './components/common/accordion/accordion.component';
import { GridComponent } from './components/common/grid/grid.component';
import { MatTableExporterModule } from 'mat-table-exporter';
import { ModalComponent } from './components/reusable/modal/modal.component';
import { RemainderComponent } from './components/reusable/remainder/remainder.component';
import { KaFooterComponent } from './components/ka-footer/ka-footer.component';
import { TruncatePipesModule } from 'src/pipes/truncate/truncate.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CustomerViewProfileComponent } from './components/common/customer-view-profile/customer-view-profile.component';
import { OffersComponent } from './modules/offers/offers.component';
import { SlideShowComponent } from './components/common/slide-show/slide-show.component';
import { PlayButtonComponent } from './modules/play-button/play-button.component';
import { SaFormComponent } from './components/sa-form/sa-form.component';
import { EditViewSlideShowComponent } from './components/common/edit-view-slide-show/edit-view-slide-show.component';
import { TicketcreationComponent } from './components/ticketcreation/ticketcreation.component';
import { ManagePhotosComponent } from './modules/manage-photos/manage-photos.component';
import { EditViewParentDetailsComponent } from './modules/edit-view-parent-details/edit-view-parent-details.component';
import { PartnerPreferencesComponent } from './modules/partner-preferences/partner-preferences.component';
import { AestroComponent } from './modules/aestro/aestro.component';
import { PropertyComponent } from './modules/property/property.component';
import { RelativeComponent } from './modules/relative/relative.component';
import { EditViewReferencesComponent } from './modules/edit-view-references/edit-view-references.component';
import { EditOfficePurposeComponent } from './modules/edit-office-purpose/edit-office-purpose.component';
import { ProfileSettingsComponent } from './modules/profile-settings/profile-settings.component';
import { SubscriptionPipeModule } from 'src/pipes/subscription/subscription-type.module';
import { ContactDetailsComponent } from './components/contact-details/contact-details.component';
import { SiblingDetailsComponent } from './components/sibling-details/sibling-details.component';
import { SpouseDetailsComponent } from './components/spouse-details/spouse-details.component';
import { ImageSliderComponent } from './components/image-slider/image-slider.component';
import { AngularMaterialModule } from './angular-material.module';
import { AutoMailPreferenceSlideShowComponent } from './components/common/auto-mail-preference-slide-show/auto-mail-preference-slide-show.component';
import { CallReasonComponent } from './components/call-reason/call-reason.component';
import { CallRecordingComponent } from './components/call-recording/call-recording.component';
import { CallLogsComponent } from './modules/call-logs/call-logs.component';
import { BankDetailsComponent } from './modules/bank-details/bank-details.component';
import { NotificationComponent } from './components/common/notification/notification.component';

@NgModule({
  declarations: [
    SearchComponent,
    ShowAllProfilesComponent,
    CommonheaderComponent,
    UpgradeMembershipComponent,
    ProfileOfTheDayComponent,
    ProfileDashboardSliderComponent,
    CompleteProfileComponent,
    SearchProfileComponent,
    ImgPreviewComponent,
    ProfileImgsliderComponent,
    DashboardContentLoaderComponent,
    ProfilePaginationComponent,
    UserDetailsSectionComponent,
    ShowCompleteDetailsOfOtherProfileComponent,
    ModalInfoComponent,
    ProfileDetailsSectionComponent,
    CommonpopupComponent,
    PartnerPreferenceComponent,
    HeaderComponent,
    AccordionComponent,
    GridComponent,
    ModalComponent,
    RemainderComponent,
    KaFooterComponent,
    CustomerViewProfileComponent,
    OffersComponent,
    SlideShowComponent,
    PlayButtonComponent,
    SaFormComponent,
    EditViewSlideShowComponent,
    TicketcreationComponent,
    ManagePhotosComponent,
    EditViewParentDetailsComponent,
    PartnerPreferencesComponent,
    AestroComponent,
    PropertyComponent,
    RelativeComponent,
    EditViewReferencesComponent,
    EditOfficePurposeComponent,
    ProfileSettingsComponent,
    SiblingDetailsComponent,
    SpouseDetailsComponent,
    ContactDetailsComponent,
    ImageSliderComponent,
    AutoMailPreferenceSlideShowComponent,
    CallReasonComponent,
    CallRecordingComponent,
    CallLogsComponent,
    BankDetailsComponent,
    NotificationComponent
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    MDBBootstrapModule.forRoot(),
    NgMultiSelectDropDownModule,
    // AnimateOnScrollModule.forRoot(),
    // ScrollEventModule,
    SlickCarouselModule,
    AngularMaterialModule,
    CarouselModule,
    Ng2SearchPipeModule,
    MatSortModule,
    TableModule,
    MatTableExporterModule,
    TruncatePipesModule,
    ScrollingModule,
    CommonModule,
    SubscriptionPipeModule
  ],
  exports: [
    SearchComponent,
    ShowAllProfilesComponent,
    CommonheaderComponent,
    UpgradeMembershipComponent,
    ProfileOfTheDayComponent,
    ProfileDashboardSliderComponent,
    CompleteProfileComponent,
    SearchProfileComponent,
    ImgPreviewComponent,
    ProfileImgsliderComponent,
    DashboardContentLoaderComponent,
    ProfilePaginationComponent,
    UserDetailsSectionComponent,
    ShowCompleteDetailsOfOtherProfileComponent,

    ModalInfoComponent,
    ProfileDetailsSectionComponent,
    CommonpopupComponent,
    PartnerPreferenceComponent,
    HeaderComponent,
    AccordionComponent,
    GridComponent,
    ModalComponent,
    RemainderComponent,
    KaFooterComponent,
    CustomerViewProfileComponent,
    OffersComponent,
    SlideShowComponent,
    PlayButtonComponent,
    SaFormComponent,
    EditViewSlideShowComponent,
    TicketcreationComponent,
    ManagePhotosComponent,
    EditViewParentDetailsComponent,
    PartnerPreferencesComponent,
    AestroComponent,
    PropertyComponent,
    RelativeComponent,
    EditViewReferencesComponent,
    EditOfficePurposeComponent,
    ProfileSettingsComponent,
    SiblingDetailsComponent,
    SpouseDetailsComponent,
    ContactDetailsComponent,
    ImageSliderComponent,
    AngularMaterialModule,
    AutoMailPreferenceSlideShowComponent,
    CallLogsComponent,
    BankDetailsComponent,
    NotificationComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SharedModuleModule { }
